<div class="list-group list-group-flush">
  <div *ngFor="let node of nodes" class="list-group-item">
    <div class="d-flex align-items-center justify-content-between">
      <div class="form-check flex-grow-1">
        <input
          class="form-check-input"
          type="checkbox"
          [id]="parentId(node)"
          [(ngModel)]="node.checked"
          [indeterminate]="node.indeterminate"
          (change)="onParentToggle(node)"
          [disabled]="disabled || !!node.loading"
        />
        <label class="form-check-label ms-2" [for]="parentId(node)">
					<ng-container *ngIf="parentLabelTemplate; else defaultParentLabel" [ngTemplateOutlet]="parentLabelTemplate" [ngTemplateOutletContext]="{ $implicit: node }"></ng-container>
					<ng-template #defaultParentLabel>{{ node.label }}</ng-template>
        </label>
      </div>
      <div class="d-flex gap-1">
        <button *ngIf="showStyle && node.type === 'geojson'"
                type="button" class="btn btn-sm btn-outline-secondary p-1"
                title="Stil ändern" (click)="styleParentNode.emit(node); $event.stopPropagation()">
          <i class="bi bi-palette"></i>
        </button>
        <button *ngIf="showDelete" type="button" class="btn btn-sm btn-outline-danger p-1"
                title="Löschen" (click)="deleteNode.emit(node); $event.stopPropagation()">
          <i class="bi bi-trash"></i>
        </button>
      </div>
    </div>

    <!-- Child list with animation -->
    <div
      [@expand]="node.checked || node.indeterminate ? 'expanded' : 'collapsed'"
      class="ps-4" style="overflow: hidden"
    >
      <div *ngIf="node.children">
        <div *ngFor="let child of node.children" class="mb-1 d-flex align-items-center">
          <input
            class="form-check-input me-2"
            type="checkbox"
            [id]="childId(node, child)"
            [(ngModel)]="child.checked"
            (change)="onChildToggle(node, child)"
            [disabled]="disabled"
          />
          <label class="form-check-label flex-grow-1 d-flex align-items-center" [for]="childId(node, child)">
						<ng-container *ngIf="childLabelTemplate; else defaultChildLabel" [ngTemplateOutlet]="childLabelTemplate" [ngTemplateOutletContext]="{ $implicit: child, parent: node }"></ng-container>
						<ng-template #defaultChildLabel>{{ child.label }}</ng-template>
          </label>
          <button *ngIf="showStyle && node.type === 'gpkg' && child.type === 'feature'"
                  type="button" class="btn btn-sm btn-outline-secondary p-1 ms-1"
                  title="Stil ändern" (click)="styleNode.emit({ parent: node, child: child }); $event.stopPropagation()">
            <i class="bi bi-palette"></i>
          </button>
          <button *ngIf="showZoom && node.type === 'gpkg' && child.type === 'feature'"
                  type="button" class="btn btn-sm btn-outline-secondary p-1 ms-1"
                  title="Auf Layer zoomen" (click)="zoomNode.emit({ parent: node, child: child }); $event.stopPropagation()">
            <i class="bi bi-search"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
